export default __webpack_public_path__ + "static/media/1.1d48583d.png";